export const isPixKeyValid = (bancoData, isValidCPF, isValidEmail, isValidPhoneBR) => {
    if (!bancoData.tipoPix || !bancoData.chavePix) return true;
    switch (bancoData.tipoPix) {
        case "cpf": return isValidCPF(bancoData.chavePix);
        case "email": return isValidEmail(bancoData.chavePix);
        case "telefone": return isValidPhoneBR(bancoData.chavePix);
        case "aleatorio": return true;
        default: return false;
    }
};

export const validateUserForm = (userData, bancoData, { isValidEmail, isValidPhoneBR, isValidCPF, isValidCEP, isValidUF }) => {
    const newErrors = {};

    if (!userData.nomeCompleto) newErrors.nomeCompleto = "Nome completo é obrigatório.";
    if (!userData.cpf) newErrors.cpf = "CPF é obrigatório.";
    if (!userData.email || !isValidEmail(userData.email)) newErrors.email = "E-mail inválido.";
    if (!userData.rg) newErrors.rg = "RG é obrigatório.";
    if (!userData.data_nascimento) newErrors.data_nascimento = "Data de nascimento é obrigatória.";
    if (!userData.telefone || !isValidPhoneBR(userData.telefone)) newErrors.telefone = "O telefone deve ter 11 dígitos.";
    if (!userData.estadoCivil) newErrors.estadoCivil = "Estado civil é obrigatório.";

    if (userData.estadoCivil === "Casado(a)") {
        if (!userData.nome_conjuge) newErrors.nome_conjuge = "Nome do cônjuge é obrigatório.";
        if (!userData.cpf_conjuge) {
            newErrors.cpf_conjuge = "CPF do cônjuge é obrigatório.";
        } else if (!isValidCPF(userData.cpf_conjuge)) {
            newErrors.cpf_conjuge = "CPF do cônjuge inválido.";
        }
    }

    if (!userData.logradouro) newErrors.logradouro = "Logradouro é obrigatório.";
    if (!userData.numero) newErrors.numero = "Número é obrigatório.";
    if (!userData.bairro) newErrors.bairro = "Bairro é obrigatório.";
    if (!userData.cep || !isValidCEP(userData.cep)) newErrors.cep = "CEP inválido.";
    if (!userData.cidade) newErrors.cidade = "Cidade é obrigatória.";
    if (!userData.estado || !isValidUF(userData.estado)) newErrors.estado = "Estado (UF) inválido.";

    if (!bancoData.nomeBanco) newErrors.nomeBanco = "Nome do banco é obrigatório.";
    if (!bancoData.agencia) newErrors.agencia = "Agência é obrigatória.";
    if (!bancoData.conta) newErrors.conta = "Conta é obrigatória.";
    if (!bancoData.tipoConta) newErrors.tipoConta = "Tipo de conta é obrigatório.";

    return newErrors;
};
